<template>
  <div
    class="image-text-tabs"
    :style="{
      padding: ($$FormData.page_edge ) * 0.5 + 'px',
      background: $$FormData.background_color
    }">
    <div
      v-if="$$FormData.tabsList.length"
      :class="['image-text-tabs__tabs']"
      :style="{
        height: ($$FormData.height ) * 0.5 + 'px'
      }"
    >
      <div
        v-for="(item, i) in $$FormData.tabsList"
        ref="iteRef"
        :key="item.__key"
        class="image-text-tabs__tabs-item"
        :style="{
          padding: ($$FormData.tabs_padding_edge ) * 0.5 + 'px'
        }"
      >
        <div
          v-if="item.tabs_type === 'image'"
          class="image-text-tabs__tabs-image"
          :style="{
            width: ($$FormData.width ) * 0.5 + 'px',
            height: ($$FormData.height * $$FormData.image_scale ) * 0.5 + 'px',
            backgroundImage: `url(${item.tabs_image.src})`
          }"
        />
        <div
          v-if="item.tabs_type === 'text'"
          class="'image-text-tabs__tabs-text'"
          :style="{
            color: $$FormData.text_color,
            fontSize: ($$FormData.title_font_size ) * 0.5 + 'px',
            fontWeight: current === i ? '600' : $$FormData.title_font_weight
          }"
        >{{ item.tabs_name }}</div>
      </div>
      <div
        v-if="$$FormData.tabs_tpl === 'underline'"
        class="image-text-tabs__tabs-line"
        :style="{
            width: lineWidth + 'px',
            height: ($$FormData.line_height ) * 0.5 + 'px',
            backgroundColor: $$FormData.line_color,
            left: lineLeft + 'px',
            transform: `translateX(-${lineWidth / 2}px)`
          }"
      >
      </div>
      <div
        v-if="$$FormData.tabs_tpl === 'capsule'"
        class="image-text-tabs__tabs-capsule"
        :style="{
            background: $$FormData.capsule_background_color,
            borderRadius: ($$FormData.tabs_margin_radius ) * 0.5 + 'px',
            left: capsuleLeft + 'px',
            width: currentWidth + 'px',
            height: ($$FormData.height * $$FormData.image_scale ) * 0.5 + 'px'
          }"
      ></div>
    </div>
    <div v-else class="image-text-tabs__empty">
      请添加标签
    </div>
  </div>
</template>

<script>
export default {
  name: "LabelModulePreview",
  data() {
    return {
      lineWidth: 30,
      currentWidth: 0, // 当前选项的宽度
      lineLeft: 0, // 滑块距离左侧的位置
      capsuleLeft: 0, // 胶囊距离左侧的位置
      containerWidth: 0, // 容器的宽度
      current: 0 // 当前选中项
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getTabItemWidth()
    })
  },
  watch: {
    $$FormData: {
      handler: 'getTabItemWidth',
      deep: true
    }
  },
  methods: {
    getTabItemWidth() {
      let data = this.$refs.iteRef
      if (!data) return
      let lineLeft = 0
      let currentWidth = 0
      for (let i = 0; i < data.length; i++) {
        if (i < this.current) {
          lineLeft += data[i].offsetWidth
        } else if (i == this.current) {
          currentWidth = data[i].offsetWidth
        } else {
          break
        }
      }
      this.currentWidth = currentWidth
      // 缩放后的滑块宽度
      this.lineWidth = currentWidth * this.$$FormData.line_scale * 1
      // 滑块作移动的位置
      this.lineLeft = lineLeft + currentWidth / 2
      // 胶囊距离左侧的位置
      this.capsuleLeft = lineLeft
    }
  }
}
</script>

<style lang="scss" scoped>
.image-text-tabs {
  box-sizing: border-box;
  overflow: hidden;
  ::-webkit-scrollbar {
    display: none;
  }
  &__tabs {
    min-width: 100%;
    position: relative;
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    overflow-x: auto;
    &-item {
      display: flex;
      align-items: center;
      height: 100%;
      position: relative;
      z-index: 10;
      transition: all 0.3s;
      white-space: nowrap;
    }
    &-image {
      display: block;
      margin: 0 auto;
      border: 0;
      background-position: 50%;
      background-size: contain;
      background-repeat: no-repeat;
    }
    &-line {
      position: absolute;
      bottom: 0;
    }
    &-capsule {
      position: absolute;
      z-index: 9;
    }
  }
  &__goods {
    margin: 5px 10px 0 10px;
  }
}
.goods-module {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 70px;
  margin: 10px auto;
  background-color: #fff;
  overflow: hidden;

  &__title {
    font-size: 15px;
    text-align: center;
  }

  &__subtitle {
    font-size: 12px;
    color: #999999;
    margin-top: 10px;
    text-align: center;
  }
}
.goods-view-single {
  margin: 10px;
  .goods-view {
    display: flex;
    flex-direction: row;
    padding: 10px 10px;
    border-radius: 10px;
    background-color: #FFFFFF;
    .goods-img {
      width: 120px;
      height: 120px;
      border-radius: 10px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .goods-info {
      flex: 1;
      margin-left: 10px;
      padding-bottom: 5px;

      .goods-price-view {
        margin: 28px 0 5px 0;
      }
    }
  }
}
.goods-view-double {
  border-radius: 10px;
  .goods-img {
    width: 170px;
    height: 170px;
    border-radius: 10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .goods-info {
    width: 95%;
    padding: 7px;
    .goods-price-view {
      margin: 5px 0;
    }
    .goods-title-view {
      height: 35px;
      max-height: 35px;
      line-height: 17px;
    }
  }
}

.goods-list {
  width: 48%;
  float: left;
  background: #ffffff;
  overflow: hidden;
  margin: 5px 0;
  border-radius: 10px;

  &.list-b {
    margin-left: 12px;
  }
}

.goods-view-list {
  .goods-title-view {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    .self {
      margin-right: 5px;
      border-radius: 4px;
      color: #FFFFFF;
      font-size: 10px;
      min-width: 30px;
      text-align: center;
      padding: 2px 4px;
      min-width: max-content;
      background: linear-gradient(to right, #FD5632 0%, #EF0D25 100%);
    }
  }
  .goods-price-view {
    color: #FA3534;
    font-weight: 600;
    .price-icon {
      font-size: 10px;
    }
    .price-text {
      font-size: 16px;
    }
  }
}
</style>